"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusScreen = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
;
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StatusScreen = ({ statusData }) => {
    if (!statusData) {
        return null;
    }
    return (react_1.default.createElement(Wrapper, { "data-testid": "checkin-completed" },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: statusData.texts.htmlText,
            } })));
};
exports.StatusScreen = StatusScreen;
exports.default = (0, react_router_dom_1.withRouter)(exports.StatusScreen);
